/**
 * Types of payment mehtods
 * @see src/mocks/paymentMethod.json file for reference
 */
export const PaymentMethods = {
  NAO_SE_APLICA: null,
  RELACAO_BANCARIA: 'B',
  PAGAMENTO_EM_DINHEIRO: 'C',
  CHEQUE_SALARIO: 'S',
  ORDEM_DE_PAGAMENTO: 'O',
  RELACAO_BANCARIA_DEP_CTA_POUPANCA: 'P',
} as const;